<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="217"
      size="mini"
      resizable
      border
      round
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <b-button
            size="sm"
            class="mr-2"
            style="width:100%"
            variant="outline-success"
            :disabled="disabled"
            @click="openInputDialog()"
          >
            <b-icon-plus></b-icon-plus>添加关联单号
          </b-button>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      v-el-dialog-drag
      append-to-body
      visible
      width="500px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => closeInputDialog()"
    >
      <el-form ref="form" :model="formData" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="关联单号" prop="linkBillNo">
              <el-input
                clearable
                style="font-size:20px;"
                v-model.trim="formData.linkBillNo"
                placeholder="请输入关联单号"
                size="medium"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="箱数" prop="linkBillBoxNum">
              <el-input
                clearable
                style="font-size:20px;"
                v-model.trim="formData.linkBillBoxNum"
                placeholder="请输入箱数"
                size="medium"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="closeInputDialog()">取消</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="addBillNo()"
          >确认添加</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  components: {},
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    totBoxNum: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      formData: {
        linkBillNo: '',
        linkBillBoxNum: '',
      },
      editFormDialogOptions: {
        visible: false,
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'left',
          width: 60,
          slots: {
            default: 'opt',
          },
        },
        {
          field: 'linkBillNo',
          title: '关联单号',
          headerAlign: 'center',
          align: 'center',
          minWidth: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'linkBillBoxNum',
          title: '箱数',
          headerAlign: 'center',
          align: 'center',
          minWidth: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
      ],
      rules: {
        linkBillNo: [
          {
            required: true,
            message: '请输入关联单号',
            trigger: 'change',
          },
        ],
        linkBillBoxNum: [
          { required: true, message: '请输入箱数' },
          {
            pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
            message: '箱数应为不小于0的数字',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    openInputDialog() {
      this.editFormDialogOptions = {
        visible: true,
        title: '添加关联单号',
      }
    },
    closeInputDialog() {
      this.editFormDialogOptions.visible = false
      this.reset()
    },
    async addBillNo() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      let flag = false
      this.tableData.forEach((item) => {
        if (item.linkBillNo === this.formData.linkBillNo) {
          this.$message.warning(`关联单号不能重复`)
          flag = true
          return
        }
      })
      if (flag) return
      if (Number(this.formData.linkBillBoxNum) > this.totBoxNum) {
        this.$message.warning(`关联单箱数不能超过总箱数`)
        this.formData.linkBillBoxNum = ''
        return
      }
      var data = [this.formData]
      data.push.apply(data, this.tableData)
      this.$emit('update:tableData', data)
      this.closeInputDialog()
      this.reset()
    },
    del(row) {
      var data = this.tableData
      let index = this.$refs.table.getRowIndex(row)
      data.splice(index, 1)
      this.$emit('update:tableData', data)
    },
    reset() {
      this.formData = {
        linkBillNo: '',
        linkBillBoxNum: '',
      }
    },
  },
}
</script>
